<template>
  <div class="toggle">
    <button v-bind:class="{'active': value == leftValue}" v-on:click="value = leftValue; $emit('change', { newValue: leftValue });">
      <div>{{ leftLabel }}</div>
      <div aria-hidden="true" style="color: transparent; height: 0;">{{ rightLabel }}</div>
    </button>
    <button v-bind:class="{'active': value == rightValue}" v-on:click="value = rightValue; $emit('change', { newValue: rightValue });">
      <div>{{ rightLabel }}</div>
      <div aria-hidden="true" style="color: transparent; height: 0;">{{ leftLabel }}</div>
    </button>
  </div>
</template>

<script>
export default {
  props: ['initialValue', 'leftValue', 'leftLabel', 'rightValue', 'rightLabel'],
  data: function () {
    return {
      value: this.initialValue
    }
  }
}
</script>

<style scoped>
  .toggle {
    border: 1px solid #fff;
    border-radius: 8px;
    line-height: 1;
    display:-webkit-inline-flex;
    display: inline-flex;
  }
  button {
    width: 50%;
    outline: none;
    border: 0;
    background: transparent;
    padding: 8px 25px;
    color: #fff;
    font-weight: 400;
    border-radius: 0;
  }
  button.active {
    background: #fff;
    color: #585858;
  }
  @media(min-width: 768px) {
    .toggle {
      border: 1px solid #585858;
    }
    button {
      color: #585858;
    }
    button.active {
      background: #585858;
      color: #fff;
    }
  }
  button:first-child {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
  button:last-child {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
</style>
